import { Button } from "antd";

import React from "react";
import FileSaver from "file-saver";   
import { useNotification } from "@refinedev/core";
import * as Icons from "@ant-design/icons";

export const DownloadVesselDataTransfer = ({ storageUrl = "", fileName = "" }) => {
    const [loading, setLoading] = React.useState(false);
    const { open, close } = useNotification();
  
    const triggerDownload = () => {
      setLoading(true);
  
      try {
        FileSaver.saveAs(storageUrl, fileName);
  
        setLoading(false);
        open?.({
          type: "success",
          message: fileName,
          description: "Downloading file",
        });
        close?.("success-notification-key");
      } catch (error) {
        setLoading(false);
        open?.({
          type: "error",
          message: "Error",
          //@ts-ignore
          description: `Error: ${error.message}`,
        });
        close?.("error-notification-key");
      }
    };
  
    return loading ? (
      <Icons.LoadingOutlined spin />
    ) : (
      <Button
        type="link"
        size="small"
        onClick={triggerDownload}
        icon={<Icons.DownloadOutlined />}
      />
    );
  };